import webApi, { baseURL } from "../../WebApi/WebApi";

export const getInvoiceBusinessUnitList = async (data) => {
  return await webApi.get(`/customer/invoice/list-business-unit`, {});
};

export const getInvoiceSupplierList = async (data) => {
  return await webApi.get(`/customer/invoice/list-suppliers`, {});
};

//invoice listing
// export const getAllInvoiceDetailsList = async (
//   data,
//   business,
//   supplier,
//   from,
//   to
// ) => {
//   if (Array.isArray(supplier) && supplier.length === 1) {
//     if (
//       !supplier[0] ||
//       (Array.isArray(supplier[0]) && supplier[0].length === 0)
//     ) {
//       supplier = "";
//       // console.log("First index of supplier is empty or contains an empty array, resetting supplier to an empty string");
//     }
//   }

//   return await webApi.post(
//     `/customer/invoice/list-invoice?searchKeyword=${data}`,
//     {
//       businessUnitName: business ? business : [],
//       suppliersName: supplier ? supplier : [],
//       fromDate: from ? from : "",
//       toDate: to ? to : "",
//     }
//   );
// };

export const getAllInvoiceDetailsList = async (
  data,
  business,
  supplier,
  from,
  to,
  signal,
  page,
  perPage
) => {
  if (Array.isArray(supplier) && supplier.length === 1) {
    if (
      !supplier[0] ||
      (Array.isArray(supplier[0]) && supplier[0].length === 0)
    ) {
      supplier = "";
    }
  }

  return await webApi.post(
    `/customer/invoice/list-invoice?searchKeyword=${data}`,
    {
      businessUnitName: business || [],
      suppliersName: supplier || [],
      fromDate: from || "",
      toDate: to || "",
      page: page+1 || 1,
      limit: perPage
    },
    {
      signal
    }
  );
};


export const getInvoiceById = async (data) => {
  return await webApi.post(`/customer/invoice/get-invoice-by-id`, {
    invoiceId: Number(data),
  });
};

//create past order
export const getCreatePastOrder = async (invoiceIds, onSuccess, onFailure) => {

  try {
    const res = await webApi.post(`/customer/past-order/add-past-order`, {
      invoiceIds: invoiceIds,
    });
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    //  console.log("fdgdf");
  }
};

export const getActiveInvoice = async (
  module,
  id,
  isactive,
  onSuccess,
  onFailure
) => {
  try {
    const res = await webApi.post(`/customer/common/is-active`, {
      module: module,
      id: id,
      isActive: isactive,
    });
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    //  console.log("fdgdf");
  }
};
